import { PresentismoSyncProcessor } from './presentismo-sync.processor';

describe('PresentismoSyncProcessor', () => {
  it('ejecuta sincronización automática del reloj', async () => {
    const relojesService = {
      sincronizar: jest.fn().mockResolvedValue({ ok: true }),
    };
    const processor = new PresentismoSyncProcessor(relojesService as any);

    await processor.process({
      id: 'job-1',
      name: 'sync-reloj-api',
      data: { relojId: 'reloj-1', empresaId: 'emp-1' },
    } as any);

    expect(relojesService.sincronizar).toHaveBeenCalledWith('reloj-1', 'emp-1', {});
  });
});
